import React from 'react';
import { ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-4 sm:px-6 lg:px-8" data-id="element-159">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-160">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-rose-light/40 blur-3xl" data-id="element-161" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-caramel-light/20 blur-3xl" data-id="element-162" />
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-163">
        <div className="text-center lg:text-left z-10" data-id="element-164">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-caramel/10 text-caramel-dark font-medium text-sm mb-6 border border-caramel/20" data-id="element-165">
            <span className="relative flex h-2 w-2" data-id="element-166">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-caramel opacity-75" data-id="element-167"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-caramel" data-id="element-168"></span>
            </span>
            Lanzamiento Oficial
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-espresso leading-tight mb-6" data-id="element-169">
            Cómo hacer tu primera venta de milhojas y galletas{' '}
            <span className="text-caramel italic" data-id="element-170">esta semana</span> desde tu
            cocina
          </h1>

          <p className="text-lg sm:text-xl text-espresso-light mb-6 font-sans max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-171">
            <strong className="text-espresso" data-id="element-172">+1,200 mamás latinas</strong> ya
            lo están haciendo desde su cocina. Sin local. Sin máquinas caras.
            Sin experiencia previa.
          </p>

          {/* Price pill */}
          <div className="inline-flex items-center gap-3 mb-6 bg-white border-2 border-caramel/30 rounded-2xl px-4 py-2 shadow-soft" data-id="element-173">
            <span className="text-sm text-espresso-light line-through font-medium" data-id="element-174">
              $29.99
            </span>
            <span className="flex items-baseline gap-1" data-id="element-175">
              <span className="text-3xl sm:text-4xl font-bold text-caramel font-serif" data-id="element-176">
                $14.99
              </span>
              <span className="text-xs font-bold text-caramel" data-id="element-177">USD</span>
            </span>
            <span className="hidden sm:inline-block text-[10px] font-bold uppercase tracking-wider bg-caramel text-white px-2 py-1 rounded-md" data-id="element-178">
              -50%
            </span>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-179">
            <a href="#cta-final" className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 bg-caramel text-white font-bold text-lg rounded-xl overflow-hidden transition-all hover:bg-caramel-dark hover:shadow-glow hover:-translate-y-1" data-id="element-180">
              <span className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-181"></span>
              <span className="relative" data-id="element-182">
                SÍ, QUIERO EMPEZAR MI NEGOCIO DULCE POR $14.99
              </span>
              <ChevronRight className="relative w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-183" />
            </a>
          </div>
          <p className="mt-4 text-sm text-espresso-light/80 flex items-center justify-center lg:justify-start gap-2" data-id="element-184">
            <span className="text-caramel" data-id="element-185">★★★★★</span> +1,200 alumnas felices
          </p>
        </div>

        <div className="relative w-full flex items-center justify-center z-10" data-id="element-186">
          <img src="https://cdn.magicpatterns.com/uploads/iGBbbQTSfakhwkXMZk7FHR/Mockup_Master_Reposteria.webp" alt="Master en Repostería en Casa - Milhojas y Galletas Gourmet para Vender" width={512} height={680} fetchPriority="high" decoding="async" loading="eager" className="w-full max-w-lg mx-auto drop-shadow-2xl h-auto hero-float" data-id="element-187" />
        </div>
      </div>
    </section>;
}